import * as React from "react";
import Loader from "../../components/atoms/Loader";
import { MergedTimelineList } from "../../components/features/Timeline/MergedTimelineList";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceStudentsPage, {
  StudentsPageProps,
} from "../../hocs/enhanceStudentsPage";
import StudentInterface from "../../interfaces/StudentInterface";
import styles from "./index.scss";
import { useMergedStudentTimeline } from "./useMergedStudentTimeline";

// StudentsPageProps は AuthenticatedPageProps を継承しており currentOperator を含む。
type Props = StudentsPageProps & {
  student: StudentInterface;
} & OutletContextProps;

// 生徒個別タイムライン。AI 質問統合表示の凍結（005-freeze-ai-question-timeline）に伴い、
// 学習記録のみを時系列降順で表示する。校舎リアルタイムタブを特定の生徒で絞り込んだ内容に
// あたり、共通フック useMergedTimeline に学習記録ソースを注入する。
// フィルタ・タブ・StudentFilter は設置しない（凍結中も骨格として維持しない）。
const StudentsTimelinePage = ({
  student,
  currentOperator,
  setActiveMenu,
}: Props) => {
  React.useEffect(() => {
    setActiveMenu("timeline");
  }, []);

  const {
    displayed,
    isLoading,
    isFetchingNextPage,
    updateStudyRecordQueryCache,
    drillProgressMap,
  } = useMergedStudentTimeline({
    sectionId: student.section.id,
    studentId: student.id,
    // enhanceStudentsPage の render ガードにより本体到達時 student は確定しているため常に有効。
    enabled: true,
  });

  if (!currentOperator) {
    return null;
  }

  if (isLoading) {
    return <Loader loading={isLoading} />;
  }

  return (
    <div className={styles.root}>
      <div>
        {displayed.length === 0 ? (
          <p className="mt-4 text-center">まだ記録がありません</p>
        ) : (
          <MergedTimelineList
            displayed={displayed}
            currentOperator={currentOperator}
            updateStudyRecordQueryCache={updateStudyRecordQueryCache}
            drillProgressMap={drillProgressMap}
            itemClassName={styles.timelineItem}
          />
        )}
      </div>
      <Loader loading={isFetchingNextPage} />
    </div>
  );
};

export default enhanceStudentsPage(StudentsTimelinePage, {
  title: "タイムライン",
});
